module.exports = " <ul class=page-sidebar-menu data-keep-expanded=false data-auto-scroll=true data-slide-speed=200> <list-menu v-for=\"item in links\" :line=item></list-menu> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/sidebarmenu/menu/navmenu.vue
// module id = 196
// module chunks = 0